import { ArrowBackIos as ArrowBackIosIcon } from '@bridge/ui/icons-material'
import { IconButton } from '@bridge/ui'
import colors from 'app/colors'

export default function LeftButton ({
	onClick,
	color,
}: {
	onClick: () => void
	color?: string
}) {
	return (
		<IconButton
			size='small'
			disableRipple
			sx={{
				color: color ?? colors.grey900,
				'&.MuiButtonBase-root:hover': {
					backgroundColor: 'transparent',
				},
			}}
			onClick={onClick}
		>
			<ArrowBackIosIcon />
		</IconButton>
	)
}
